﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GUIController = void 0;
const gs = require("@ivanlog/gs");
const DesignThemeEnum_1 = require("../enums/DesignThemeEnum");
const AppControllerBase_1 = require("./AppControllerBase");
class GUIController extends AppControllerBase_1.AppControllerBase {
    constructor(app) {
        super(app);
        this._lockCounter = 0;
        this._body = gs.q('body').first;
        this._container = gs.q('main').first;
        this._tabsContainer = gs.q('.asap-tabs_container').first;
    }
    setTabs(tabs) {
        this._tabsContainer.html = '';
        this._tabsContainer.append(tabs);
    }
    clearTabs() { this._tabsContainer.html = ''; }
    showPage(page) {
        if (this._page)
            this._page.cut();
        this._page = page;
        this._container.append(page);
        const newTheme = page.getData('theme');
        if (newTheme) {
            const themeEnum = DesignThemeEnum_1.DesignThemeEnum[newTheme];
            if (themeEnum)
                this.setTheme(themeEnum);
        }
        page.show();
    }
    hidePage() {
        if (!this._page)
            return;
        this._page.cut();
        this._page = undefined;
    }
    lock() {
        if (this._lockCounter === 0)
            this._container.disable();
        this._lockCounter++;
    }
    unlock() {
        this._lockCounter--;
        if (this._lockCounter === 0)
            this._container.enable();
    }
    lockAction(action) {
        return __awaiter(this, void 0, void 0, function* () {
            this.app.gui.lock();
            const r = yield action;
            this.app.gui.unlock();
            return r;
        });
    }
    setTheme(theme) {
        for (const i in this._body.el.classList) {
            const c = this._body.el.classList[i];
            if (!c)
                continue;
            if (c.indexOf)
                if (c.indexOf('theme') === 0)
                    this._body.removeClass(c);
        }
        if (theme)
            this._body.addClass(`theme_${theme}`);
    }
}
exports.GUIController = GUIController;
//# sourceMappingURL=GUIController.js.map